import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { DropDown } from '../../../common/dropdown';
import { REDUCER_NAME, changeOption } from './reducer';

class DropDownNetVol extends React.Component {
  getListDataByKey = () => {
    const data = I18n.t('topForeignTrade.optionList');
    return Object.keys(data).reduce((result, key) => {
      return {
        ...result,
        [key]: { key, name: data[key] },
      };
    }, {});
  };

  onChange = option => {
    const { changeOption } = this.props;
    changeOption(option);
  };

  render() {
    const { option } = this.props;

    return (
      <div className="line-drop" style={{ marginTop: '-10px' }}>
        <DropDown
          listKey={Object.keys(I18n.t('topForeignTrade.optionList'))}
          listDataByKey={this.getListDataByKey()}
          currentKey={option}
          keyTitle={'name'}
          change={this.onChange}
          isEditable={false}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    filter: state[REDUCER_NAME].filter,
    option: state[REDUCER_NAME].option,
  };
};

const mapDispatchToProps = {
  changeOption,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DropDownNetVol);
